module.exports = __webpack_public_path__ + "d9cc3e31244ac3d1fb3b097c4ba885e4.svg";